import { Badge } from '@mui/material';
import useThemeStore from 'Theme/store';
import { cn } from 'utils/styles';

function FilterButton({ label, icon, badgeCount, onClick }) {
  const { theme } = useThemeStore();

  return (
    <div
      className={cn(
        'font-figtree flex items-center h-8 border-2 rounded-[10px] px-[0.3rem] py-0.5 min-w-[160px] shadow-[0_2px_8px_0_rgba(16,30,54,0.04)] cursor-pointer select-none relative',
        {
          'bg-seasalt border-cool-gray/30 text-raisin-black': theme === 'light',
          'bg-lead border-tornado-cloud text-crystal-bell': theme === 'dark',
        }
      )}
      onClick={onClick}
    >
      <span className="flex-1 font-normal text-sm leading-[18px]">{label}</span>
      <Badge
        badgeContent={badgeCount > 0 ? badgeCount : null}
        color="primary"
        overlap="circular"
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {icon}
      </Badge>
    </div>
  );
}

export default FilterButton;
